import { useEffect } from 'react';

import { ApplicationStage } from '@App/interfaces/application-stage.enum';
import { RecommendedOffers } from '@App/interfaces/offer';
import { getRecommendedOffers } from '@App/requests/getOfferData';

interface useIsNeedsAndPreferencesCompleteProps {
    applicationEmail: string;
    applicationId: string;
    setNeedsAndPreferencesCompleted: (v: boolean) => void;
    setLoading: (v: boolean) => void;
    applicationStage: '' | ApplicationStage;
    setRecommendedOffers: (v: RecommendedOffers | null) => void;
    getAccessToken: Function;
    getIdToken: Function;
    hasDeclinedOffer: boolean | null;
}

export const useIsNeedsAndPreferencesComplete = ({
    applicationEmail,
    applicationId,
    setNeedsAndPreferencesCompleted,
    setLoading,
    applicationStage,
    setRecommendedOffers,
    getAccessToken,
    getIdToken,
    hasDeclinedOffer,
}: useIsNeedsAndPreferencesCompleteProps) => {
    useEffect(() => {
        const setNeedsAndPreferencesStatus = async () => {
            if (
                applicationEmail &&
                applicationId &&
                applicationStage === ApplicationStage.DECISIONING_ACCEPT
            ) {
                if (hasDeclinedOffer === false) {
                    setLoading(true);

                    try {
                        const response = await getRecommendedOffers(
                            applicationId,
                            await getAccessToken(),
                            await getIdToken(),
                        );

                        if (response.success) {
                            setNeedsAndPreferencesCompleted(true);
                            setRecommendedOffers(response);
                        } else {
                            setNeedsAndPreferencesCompleted(false);
                        }
                    } finally {
                        setLoading(false);
                    }
                }

                // N&P is skipped if user has a declined offer
                if (hasDeclinedOffer === true) {
                    setNeedsAndPreferencesCompleted(true);
                }
            }
        };

        setNeedsAndPreferencesStatus();
    }, [
        applicationEmail,
        setLoading,
        setNeedsAndPreferencesCompleted,
        applicationId,
        getAccessToken,
        getIdToken,
        applicationStage,
        setRecommendedOffers,
        hasDeclinedOffer,
    ]);
};
